// Design tokens for the Editorial landing page.
//
// Ported from the "Lyfe - Editorial" design. Real brand fonts (Nib Pro /
// Telegraf) are loaded via styles/fonts.less and take precedence; Newsreader /
// Space Grotesk remain as fallbacks in the stacks below.

export const colors = {
  bg: '#0A0A0C',
  bgAlt: '#0C0C0F',
  bgDeep: '#070709',
  ink: '#F4F3F0',
  inkSoft: '#E7E7EC',
  muted: '#C4C4CB',
  muted2: '#9a9aa2',
  muted3: '#8a8a92',
  muted4: '#75757d',
  muted5: '#5a5a62',
  orange: '#E8632B',
  blue: '#5760F2',
  indigo: '#6E60D6',
};

export const fonts = {
  serif: "'Nib Pro','Newsreader',serif",
  sans: "'Telegraf','Space Grotesk',sans-serif",
};

// Hairline borders used throughout the design.
export const line = {
  faint: '1px solid rgba(255,255,255,.08)',
  soft: '1px solid rgba(255,255,255,.09)',
  card: '1px solid rgba(255,255,255,.1)',
};

// Max content width + horizontal gutter shared by every section.
export const container = {
  maxWidth: 1280,
  margin: '0 auto',
  padding: '0 40px',
  width: '100%',
};

// Small uppercase section label (eyebrow). Pass a color to override.
export const eyebrow = (color = colors.blue) => ({
  fontSize: 12,
  letterSpacing: '.24em',
  textTransform: 'uppercase',
  color,
  fontWeight: 600,
  marginBottom: 20,
});

// Large serif section heading.
export const sectionHeading = {
  fontFamily: fonts.serif,
  fontWeight: 300,
  fontSize: 'clamp(38px,4.6vw,62px)',
  lineHeight: 1.04,
  letterSpacing: '-.01em',
};
